var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.397,
    height: 16,
    viewBox: "0 0 11.397 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "save",
    d: "M343.62,459.089a.691.691,0,0,1-.467-.182l-4.539-4.153-4.538,4.153a.693.693,0,0,1-1.16-.511V445.039a1.95,1.95,0,0,1,1.945-1.949h7.508a1.949,1.949,0,0,1,1.944,1.949V458.4a.692.692,0,0,1-.414.633A.685.685,0,0,1,343.62,459.089Zm-5.006-5.965a.69.69,0,0,1,.468.182l3.846,3.519V445.039a.554.554,0,0,0-.559-.563h-7.508a.555.555,0,0,0-.56.563v11.787l3.846-3.519A.688.688,0,0,1,338.614,453.125Z",
    transform: "translate(-332.916 -443.09)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.a978a8675ce2273306ee54ed3911aefc.svg";
export { ForwardRef as ReactComponent };